import { DISTRIBUTOR, DOMAIN } from '@autopass-web/domain';

export const PATH = Object.freeze({
  POIS: '/pois',
  SEARCH_PLATE_NUMBER: '/search-plate-number',
  SELECT_PLATE_NUMBER: '/select-plate-number',
  LEAVE: '/leave',
  PAYMENT: '/payment',
  SELECT_INVOICE: '/select-invoice',
  SUCCESS: '/success',
  PROMOTION: '/promotion',
  ERROR: '/error',
  AUTH: '/auth',
});

export const URL_TERMS = `${DOMAIN.AUTOPASS_URL}/terms`;
export const URL_PRIVACY = `${DOMAIN.AUTOPASS_URL}/privacy`;
export const URL_MOCHIPAY = DOMAIN[DISTRIBUTOR.MOCHIPAY];

export const vehicle = {
  car: '汽車',
  moto: '機車',
};

export const ERROR_CODES = Object.freeze({
  NO_EXIST: 'no_exist',
  NO_SESSION: 'no_session',
  NO_EXIST_RECORD: 'no_exit_record',
  PARKINGLOT_ERROR: 'parkinglot_error',
  PARKINGLOT_SETTING_ERROR: 'parkinglot_setting_error',
  FORM_VALIDATION_ERROR: 'form_validation_error',
  PAYMENT_ERROR: 'payment_error',
  NO_SIMILAR_LICENSE_PLATE: 'no_similar_license_plate',
  APS_DISABLED: 'aps_disabled',
});
